export default "__VITE_ASSET__Dgayb$uu__"